import { useCallback, useContext } from 'react';

import type { Toggle } from '@sorare/wallet-shared';
import { MessagingContext } from '@sorare/wallet-shared';

const useToggleWallet = () => {
  const { sendRequest } = useContext(MessagingContext)!;

  return useCallback(
    async (open: boolean) => sendRequest<Toggle>('toggle', { display: open }),
    [sendRequest]
  );
};

export default useToggleWallet;
